import api from './api';

export const requestAbsence = (employeeId, data) => 
  api.post(`/absences/employees/${employeeId}/requests`, data);

export const requestAbsenceWithAttachment = (employeeId, formData) => 
  api.post(`/absences/employees/${employeeId}/requests-with-attachment`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getAllAbsences = () => 
  api.get('/absences/');

export const getMyAbsences = (employeeId) => 
  api.get(`/absences/employees/${employeeId}`);

export const updateAbsenceStatus = (absenceId, data) => 
  api.put(`/absences/${absenceId}`, data);

export const deleteAbsence = (absenceId) => 
  api.delete(`/absences/${absenceId}`);

export const getAbsenceById = (absenceId) => 
  api.get(`/absences/${absenceId}`);
